// Register the subset of ECharts modules our chart components actually
// use. Tree-shaking saves ~80% of the ECharts bundle, so every entry
// here is one a real chart depends on — don't speculatively add modules.
//
// **Renderer pin.** Round-4 security: every `init()` call must request
// the canvas renderer; the SVG renderer mode is unreachable so author
// strings can't reach DOM-side text/style escaping paths. ECharts text
// renders through canvas `fillText` only. Vue components must call
// `init(el, theme, { renderer: "canvas" })` — see the Shadow-DOM XSS
// regression test under tests/embed/element.

import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import {
  BarChart,
  BoxplotChart,
  CandlestickChart,
  CustomChart,
  FunnelChart,
  GaugeChart,
  HeatmapChart,
  LineChart,
  PieChart,
  RadarChart,
  SankeyChart,
  ScatterChart,
  SunburstChart,
  TreeChart,
} from "echarts/charts";
import {
  CalendarComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  MarkAreaComponent,
  MarkLineComponent,
  MarkPointComponent,
  PolarComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
} from "echarts/components";

use([
  CanvasRenderer,
  // Charts
  BarChart,
  BoxplotChart,
  CandlestickChart,
  CustomChart,
  FunnelChart,
  GaugeChart,
  HeatmapChart,
  LineChart,
  // PieChart powers donut + pie + (visually) the funnel-cap variants.
  PieChart,
  RadarChart,
  SankeyChart,
  ScatterChart,
  SunburstChart,
  TreeChart,
  // Components
  CalendarComponent,
  DataZoomComponent,
  GridComponent,
  LegendComponent,
  // MarkLine/Area/Point power the `annotations` opt on time-series
  // specs (hline / vline / band / label kinds).
  MarkAreaComponent,
  MarkLineComponent,
  MarkPointComponent,
  // PolarComponent powers polar_bar (and polar coord-system reuse on
  // any chart that opts in via spec.polar — currently polar_bar only).
  PolarComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent,
]);
